module.exports = __webpack_public_path__ + "static/media/ellation-consent-logo.caae421c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/viewer-consent/ellation-consent-logo.png
// module id = 652
// module chunks = 0